import styled, { css, keyframes } from 'styled-components';

import { floorGameDuration as duration, styledInteraction, styledTypography } from '@pkg/primitives';

import { tokens } from './CommonSolo.tokens';

interface LoadingIndicatorProps {
    $loading?: boolean;
}

const textBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    letter-spacing: -0.02em;
    line-height: 1.2;
`;

const pulseMotion = keyframes`
    0%,
    10% {
        scale: 0.9;
        opacity: 0;
    }
    20% {
        scale: 1.06;
        opacity: 1;
    }
    100% {
        scale: 1.4;
        opacity: 0;
    }
`;

export const Section = styled.div`
    display: grid;
    gap: ${tokens.gap.mobile}px;
    justify-items: center;
    text-align: center;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: ${tokens.gap.desktop}px;
    }
`;

export const LoadingIndicator = styled.div<LoadingIndicatorProps>`
    position: relative;

    &::before,
    &::after {
        ${styledInteraction.interactionDisable};
        z-index: 2;
        position: absolute;
        inset: 0;
        opacity: 0;
        border: 3px solid rgb(255, 255, 255, 0.6);
        border-radius: 50%;
        animation-duration: ${duration.crawl * 2}ms;
        animation-timing-function: ease-out;
        animation-iteration-count: infinite;
        animation-fill-mode: both;
    }

    &::after {
        animation-delay: ${duration.crawl}ms;
    }

    ${({ $loading }) =>
        $loading &&
        css`
            &::before,
            &::after {
                content: '';
                display: block;
                animation-name: ${pulseMotion};
            }
        `};
`;

export const SectionText = styled.div`
    display: grid;

    > p:nth-child(n + 2) {
        margin-top: 1em;
    }
`;

export const Title = styled.p`
    ${textBase};
    font-size: ${tokens.titleSize.mobile}px;
    font-weight: 700;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${tokens.titleSize.desktop}px;
    }
`;

export const Subtitle = styled.p`
    ${textBase};
    font-size: ${tokens.subtitleSize.mobile}px;
    color: rgba(255, 255, 255, 0.5);

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${tokens.subtitleSize.desktop}px;
    }
`;
